
import createLink from '../../../../../libs/createLink';
import Drawer from '../../../../components2/Drawer/Drawer';
import Button, { BUTTON_VARIANTS } from '../../../../components2/UI/Button/Button';
import './DrawerMeet.scss';
import datingImg from './dating.jpg';

const DrawerMeet = ({ open, handleClose }) => {
    return (
        <Drawer
            small
            open={open} 
            handleClose={handleClose} 

            >
            <div className='drawer-meet'>
                <img src={datingImg} alt="Location" style={{width:240, height:'auto'}}/>
                <p>Vous devez activer l'affichage de votre profil dans les résultats de recherche de rencontre pour utiliser cette fonctionnalité</p>
                <Button full variant={BUTTON_VARIANTS.REVERSE} style={{marginBottom:'12px'}} isLink to={createLink('userMeSettingsDating')}>Mes paramètres de rencontre</Button>
                <Button onClick={handleClose} full>Fermer</Button>
            </div>
        </Drawer>
    )
}

export default DrawerMeet;